'use client'

import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { Breadcrumb, Breadcrumbs, Link } from '@redteclab/web-ui-react'

import { useGlobalConfigContext } from '../../../../global-config'
import { urlResolverGetBrandsIndexPage } from '../../../../url-handling'

export const StoryblokBrandBreadcrumbs: FC<{
  currentBrand: string
}> = ({ currentBrand }) => {
  const publicGlobalConfig = useGlobalConfigContext()

  return (
    <section className="container">
      <Breadcrumbs>
        <Breadcrumb>
          <Link href={urlResolverGetBrandsIndexPage(publicGlobalConfig)}>
            <FormattedMessage id="general.label.brands" />
          </Link>
        </Breadcrumb>
        <Breadcrumb>{currentBrand}</Breadcrumb>
      </Breadcrumbs>
    </section>
  )
}
